import slugify from 'slugify'

import routes from '@/internal/constants/routes'

type Props =
  | {
      __typename:
        | 'DatoCmsPctPaper'
        | 'DatoCmsPctPost'
        | 'DatoCmsPctInterview'
        | 'DatoCmsPctDialog'
        | 'DatoCmsPctPage'
        | 'DatoCmsPctTag'
        | 'DatoCmsPctTopic'
        | 'DatoCmsPctProject'
        | 'DatoCmsPctInternalPage'
        | 'DatoCmsPctEpisode'
        | 'DatoCmsPctVision'
        | 'DatoCmsPctReport'
        | 'DatoCmsPctExternalContent'
      slug: string | null
    }
  | {
      __typename: 'DatoCmsPctEvent'
      slug: string | null
      redirectToRegistration?: boolean | null
      registrationUrl?: string | null
    }
  | {
      __typename: 'DatoCmsGctPerson'
      firstName: string | null
      secondName: string | null
    }
  | null
export function generateUrlFromNode(item: Props): string {
  if (!item) return ''

  // Handle redirect to registration for events
  if (
    item.__typename === 'DatoCmsPctEvent' &&
    item.redirectToRegistration &&
    item.registrationUrl
  ) {
    return item.registrationUrl
  }

  let url = ''

  if (item.__typename === 'DatoCmsGctPerson') {
    if (item.firstName && item.secondName) {
      url = generateSlug([item.firstName, item.secondName])
    }
  } else {
    url = item.slug ?? ''
  }

  const routesPrefix: Record<string, string> = {
    DatoCmsPctPaper: routes.paperRoute,
    DatoCmsPctPost: routes.postRoute,
    DatoCmsPctInterview: routes.interviewRoute,
    DatoCmsPctDialog: routes.dialogRoute,
    DatoCmsPctPage: routes.pageRoute,
    DatoCmsPctTag: routes.tagRoute,
    DatoCmsPctTopic: routes.topicRoute,
    DatoCmsPctProject: routes.projectRoute,
    DatoCmsPctInternalPage: routes.internalPageRoute,
    DatoCmsPctEpisode: routes.episodeRoute,
    DatoCmsGctPerson: routes.personRoute,
    DatoCmsPctVision: routes.visionRoute,
    DatoCmsPctReport: routes.reportRoute,
    DatoCmsPctEvent: routes.eventRoute,
    DatoCmsPctExternalContent: ''
  }

  if (item.__typename === 'DatoCmsPctExternalContent') {
    return url
  }

  const prefix = routesPrefix[item.__typename]
  return `${prefix}/${url}/`
}

export function generateSlug(input: string | string[]): string {
  const stringToSlugify = Array.isArray(input) ? input.join(' ') : input

  return slugify(stringToSlugify, {
    lower: true,
    strict: true,
    remove: /[*+~.()'"!:@]/g
  })
}
